import React from "react";
import ArticleSearchContainer from "../../containers/ArticleSearchContainer";
import FormItemsContainer from '../../containers/FormItemsContainer';
import { handleChangeIds } from "../../../utils/checkBoxFunc";
import {countHits} from "../../../utils/checkBoxFunc";


const ExtendedAreaCheckBoxList = () => {
  const { areaIds, volOrJob, setAreaIds, onlineChecked, canJoinFarawayChecked, aggs } = ArticleSearchContainer.useContainer();
  const { items } = FormItemsContainer.useContainer();
  return (
    <ul className='searchList extendedAreaList'>
      {items.extended_areas[volOrJob].opts.map(item => {
        return(
          <li key={item.value}>
            <label className="itemWrap">
              <input
                type="checkbox"
                value={item.value}
                checked={item.value=='online' ? onlineChecked : canJoinFarawayChecked}
                onChange={handleChangeIds(areaIds, setAreaIds)}
              />
              {`${item.label}(${countHits(aggs.area_count.area.buckets, item.value)})`}
            </label>
          </li>
        )
      })}
    </ul>
  )
};

export default ExtendedAreaCheckBoxList;